import type { PdfComponent } from '../../../TermsAndConditionsRender/components/typed';

export const SECTION8: PdfComponent = {
  type: 'section',
  id: 's1s8',
  title: '8. General Obligation to Comply with Data Privacy Laws',
  content: [
    {
      type: 'altText',
      id: 's1s8bullets',
      content: [
        'The parties shall agree and maintain breach reporting protocols to ensure appropriate liaison and collaboration in order to meet their legal obligations to report breaches of Data Privacy Laws to the relevant Regulator.',
      ],
      boldFirst: false,
    },
  ],
};
